var app = angular.module("leonardo");

var WorkOrderValueForm = function($scope, $rootScope, $state, workOrderValOjb, AccountUserService, ngDialog,
                                  FormErrorsService, AccountService, AuthDataService, PermissionService,
                                  PropertyService, WhiteLabelService, WorkOrderCVService, WorkOrderService, ClientInstanceService) {

  $scope.action = $state.current.action;
  $scope.workOrderValue = workOrderValOjb;
  $scope.permissionService = PermissionService;
  $scope.propertyService = PropertyService;
  $scope.authDataService = AuthDataService;
  $scope.whiteLabelService = WhiteLabelService;
  $scope.clientInstanceService = ClientInstanceService;
  $scope.workOrderCVService = WorkOrderCVService;
  $scope.workOrderService = WorkOrderService;
  $scope.tabsCollapsed = [];

  if ($scope.action === 'edit'){
    $scope.data = angular.copy($scope.workOrderValue);
    $scope.data.client_instance = ($scope.data.client_instance && $scope.data.client_instance.id) ? $scope.data.client_instance.id : $scope.data.client_instance;
    if (!isEmpty($scope.data.properties)) {
      var properties = [];
      angular.forEach($scope.data.properties, function(property) {
       properties.push(property.id);
      });
      $scope.data.properties = properties;
    }
    $scope.data.account = $scope.data.account ? ($scope.data.account.id || $scope.data.account) : null;
    $scope.data.pms_platform = $scope.data.pms_platform ? ($scope.data.pms_platform.id || $scope.data.pms_platform) : null;
  }
  else {
    $scope.data = {
      client_instance: AuthDataService.getClientInstance(),
      //white_label: AuthDataService.getWhiteLabel(),
      properties: []
    };
    if (AuthDataService.isNotStaff()) {
      $scope.data.account = AccountUserService.currentAccountUser.account;
    }
  }

  $scope.toggleTab = function(tab) {
    if ($scope.tabHidden(tab)) {
      $scope.tabsCollapsed.splice($scope.tabsCollapsed.indexOf(tab), 1);
    }
    else {
      $scope.tabsCollapsed.push(tab);
    }
  };

  $scope.tabHidden = function(tab) {
    return _.contains($scope.tabsCollapsed, tab);
  };

  $scope.getData = function() {
    var data = angular.copy($scope.data);
    delete(data.id);
    if (isNull($scope.data.properties)) {
      data.properties = [];
    }
    return data;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
    if ($scope.action === 'edit'){
      $scope.workOrderValue.patch(data).then(function(result){
        $scope.workOrderCVService.updateCollection(result);
        $state.go('work-orders.custom-values');
      });
    }
    else {
      $scope.workOrderCVService.post(data).then(function(result) {
        $scope.workOrderCVService.updateCollection(result);
        $state.go('work-orders.custom-values');
      });
    }
  };
};

app.controller('WorkOrderValueForm', ['$scope', '$rootScope', '$state', 'workOrderValOjb', 'AccountUserService',
  'ngDialog', 'FormErrorsService', 'AccountService', 'AuthDataService', 'PermissionService', 'PropertyService',
  'WhiteLabelService', 'WorkOrderCVService', 'WorkOrderService', 'ClientInstanceService', WorkOrderValueForm]);
